module.exports = __webpack_public_path__ + "static/media/IMG_20200206_212858.d7beb3de.jpg";